module.exports = function getResource(label, vars = []) {
    let resources = {
        usOnly: 'Sorry, this page is only available within the US.',
        continue: 'Continue Shopping'
    };

    return resources[label];
};
